<template>

</template>

<script>
export default {
    data(){
        return{
            // url:"http://192.168.88.80:8011/",
            url:"http://www.bd-gps.com/bdgps/",
            // url:"http://chaxun.kcbdgps.com/bdgps/",
            // url: "http://192.168.88.211:8875/",
            type:""
        }
    },
    methods:{
        yanzheng(){
            this.$axios.get(this.url + "api/WePay/GetCode",{
                params: {
                    type:this.type,
                    imei:"",
                }
            })
            .then(res=>{
                console.error(res.data)
                if(res.data.result == "success") {
                    var data = res.data.Data
                    // this.$router.push({ 
                    //     name: 'login', 
                    //     params: { detail: res.data.Data }
                    // })
                    // localStorage.setItem("imeiDetail",JSON.stringify(res.data.Data))
                    console.log(res.data.Data)
                    window.location = res.data.Data
                }else{
                    this.$dialog({
                        id:'my-dialog',
                        title: "提示！",
                        content:res.data.Message,
                        noOkBtn:true,
                        cancelBtnTxt:"我知道了"
                    });
                }
            })
            .catch((error)=>{
                this.loading.hide();
                console.log(error)
            })
        },
        GetRequest() {
            var url = window.location.search
            //获取url中"?"符后的字串  
            console.log(url)
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                let str = url.substr(1);
                let strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
    },
    mounted(){
        let dizhi = this.GetRequest()
        console.error(dizhi)
        this.type = dizhi.type || ""
        this.yanzheng()
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/first.vue